<template>
  <div>
    <label class="titlePage">Alterações</label>

    <fccTable
      striped
      hover
      responsive
      search
      pagination
      :fields="fields"
      :items="listaAlteracoes"
      :porPage="itemsPorPage"
      @row-selected="selecionaLinha"
    />
    <div class="text-right mb-3">
      <fcc-button @click="deletar" :disabled="dadosSelecionados.length === 0">{{
        labelsSystem.excluir
      }}</fcc-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['listaAlteracoes'],
  data() {
    return {
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: false
        },
        { key: 'tpapresentacaoclassificacao', label: 'Tipo Apresentação', sortable: true },
        { key: 'cidadeclassificacao', label: 'Opção de Classificação', sortable: true },
        { key: 'rotulo', label: 'Rótulo', sortable: true },
        { key: 'tecnico', label: 'Técnico', sortable: true },
        { key: 'dtinsert', label: 'Data Importação', sortable: true }
      ],
      itemsPorPage: '10',
      dadosSelecionados: []
    }
  },
  methods: {
    selecionaLinha(value) {
      this.dadosSelecionados = value
    },
    deletar() {
      this.$emit('deletar', this.dadosSelecionados)
    }
  }
}
</script>